import { Link } from "react-router-dom";
import { Overline, Panel, Section } from "@/components/shared/Primitives";
import ProjectCard from "@/components/ProjectCard";

const List = ({ heading, items, testId }) => (
  <Panel data-testid={testId} className="bg-[#12141C]/45">
    <Overline className="!text-[10px] !tracking-[0.35em]">{heading}</Overline>
    <ul className="mt-6 space-y-4">
      {items.map((item) => (
        <li key={item} className="flex gap-3 text-sm leading-relaxed text-[#F4F6FB]/70">
          <span className="mt-2 h-1.5 w-1.5 shrink-0 rounded-full bg-[#8B5CF6]" />
          {item}
        </li>
      ))}
    </ul>
  </Panel>
);

export const CapabilityPanels = ({ capability }) => (
  <Section testId="capability-detail" className="!pt-0">
    <div className="grid gap-6 md:grid-cols-2">
      <List heading="What we build" items={capability.build} testId="capability-build" />
      <List heading="Where it can be used" items={capability.where} testId="capability-where" />
      <List
        heading="Typical deliverables"
        items={capability.deliverables}
        testId="capability-deliverables"
      />
      <Panel data-testid="capability-tech" className="bg-[#12141C]/45">
        <Overline className="!text-[10px] !tracking-[0.35em]">Relevant technologies</Overline>
        <div className="mt-6 flex flex-wrap gap-3">
          {capability.tech.map((t) => (
            <span
              key={t}
              className="rounded-full border border-white/10 px-4 py-2 font-mono text-[10px] uppercase tracking-[0.22em] text-[#F4F6FB]/65"
            >
              {t}
            </span>
          ))}
        </div>
      </Panel>
    </div>
  </Section>
);

export const CapabilityRelatedWork = ({ projects }) => (
  <Section testId="capability-projects" className="!pt-0">
    <Overline className="mb-6">Relevant work</Overline>
    <h2 className="font-display text-2xl font-bold text-[#F4F6FB] md:text-4xl">
      Projects in this capability.
    </h2>
    <div className="mt-12 grid gap-8 lg:grid-cols-2 lg:gap-10">
      {projects.map((p, i) => (
        <ProjectCard key={p.slug} project={p} index={i} />
      ))}
    </div>
  </Section>
);

export const CapabilityOthers = ({ others }) => (
  <Section testId="capability-others" className="!pt-0 !pb-16">
    <Overline className="mb-6">Other capabilities</Overline>
    <div className="flex flex-wrap gap-3">
      {others.map((c) => (
        <Link
          key={c.slug}
          to={`/capabilities/${c.slug}`}
          data-testid={`capability-other-${c.slug}`}
          className="rounded-full border border-white/10 px-5 py-2.5 font-mono text-[10px] uppercase tracking-[0.25em] text-[#F4F6FB]/60 transition-colors duration-300 hover:border-[#8B5CF6]/50 hover:text-[#F4F6FB]"
        >
          {c.id} — {c.name}
        </Link>
      ))}
    </div>
  </Section>
);
